import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps, theme, Tooltip } from 'antd';

import CopiedIcon from 'assets/images/icons/copied.svg?react';
import CopyIcon from 'assets/images/icons/copy.svg?react';
import { copyToClipboard } from 'shared/utils';

interface ICopyButtonProps extends ButtonProps {
	text: string;
	tooltipText?: string;
	textMode?: boolean;
	onCopied?: (copied: boolean) => void;
	withoutTooltip?: boolean;
}

export const CopyButton: FC<ICopyButtonProps> = ({
	text,
	icon = <CopyIcon />,
	tooltipText,
	textMode,
	onCopied,
	withoutTooltip,
	...props
}) => {
	const { t } = useTranslation();
	const {
		token: { colorSuccess },
	} = theme.useToken();
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		try {
			await copyToClipboard(text);
			setCopied(true);
			onCopied?.(true);
			setTimeout(() => setCopied(false), 1500);
		} catch {
			onCopied?.(false);
		}
	};
	return (
		<Tooltip
			title={textMode || withoutTooltip ? undefined : copied ? t('Скопировано!') : tooltipText || t('Скопировать')}>
			<Button
				{...props}
				icon={textMode ? undefined : copied ? <CopiedIcon style={{ color: colorSuccess }} /> : icon}
				onClick={handleCopy}>
				{textMode ? (copied ? t('Скопировано!') : tooltipText || t('Скопировать')) : null}
			</Button>
		</Tooltip>
	);
};
